import React from "react";
import { Box } from "@mui/material";
import { DocumentVersionHistory } from "./documentsChangeLogApi";

interface PrintPreviewChangeLogViewProps {
  versions: DocumentVersionHistory[];
  lang?: "pl" | "en";
}

export const PrintPreviewChangeLogView: React.FC<
  PrintPreviewChangeLogViewProps
> = ({ versions, lang = "en" }) => {
  const t = {
    pl: {
      docNo: "Numer dokumentu",
      version: "Wersja",
      author: "Autor",
      status: "Status",
      date: "Data",
      changes: "Zmiana",
      reason: "Powód",
      noChanges: "Brak zmian (utworzenie wersji)",
    },
    en: {
      docNo: "Document number",
      version: "Version",
      author: "Author",
      status: "Status",
      date: "Date",
      changes: "Change",
      reason: "Reason",
      noChanges: "No changes (initial version)",
    },
  }[lang];

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        p: 2,
        border: "1px solid #ddd",
        fontFamily: `Arial, "Helvetica Neue", Helvetica, sans-serif`,
        lineHeight: 1.6,
        "& table": {
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: "16px",
          pageBreakInside: "avoid",
        },
        "& th, & td": {
          border: "1px solid #000",
          padding: "6px 8px",
          verticalAlign: "top",
          fontSize: "0.9rem",
        },
        "& th": { backgroundColor: "#f0f0f0", fontWeight: 700 },
        "@media print": { border: "none", p: 0 },
      }}
    >
      <table>
        <thead>
          <tr>
            <th>{t.version}</th>
            <th>{t.docNo}</th>
            <th>{t.author}</th>
            <th>{t.status}</th>
            <th>{t.date}</th>
          </tr>
        </thead>
        <tbody>
          {versions.map((v) => (
            <React.Fragment key={v.id}>
              <tr>
                <td>{v.version}</td>
                <td>{v.no}</td>
                <td>{v.createdByFullName}</td>
                <td>{v.status}</td>
                <td>
                  {new Date(v.createDate).toLocaleDateString(
                    lang === "pl" ? "pl-PL" : "en-GB"
                  )}
                </td>
              </tr>

              {/* zmiany jako podtabela */}
              <tr>
                <td colSpan={5} style={{ padding: 0 }}>
                  {v.changeLogs.length > 0 ? (
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <thead>
                        <tr>
                          <th>{t.changes}</th>
                          <th>{t.reason}</th>
                          <th>{t.author}</th>
                          <th>{t.date}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {v.changeLogs.map((ch, idx) => (
                          <tr key={ch.id ?? idx}>
                            <td>{ch.changeDescription}</td>
                            <td>{ch.changeReason}</td>
                            <td>{ch.createdByFullName}</td>
                            <td>
                              {new Date(ch.createDate).toLocaleDateString(
                                lang === "pl" ? "pl-PL" : "en-GB"
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <div
                      style={{
                        fontStyle: "italic",
                        color: "#777",
                        padding: "6px 8px",
                      }}
                    >
                      {t.noChanges}
                    </div>
                  )}
                </td>
              </tr>
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </Box>
  );
};
